import { Button, Form, Input, message, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import AntIcon from './../wrappers/AntIcon';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import axios from 'axios';
import ImageWithSkeleton from './ImageWithSkeleton';
import UploadButton from './UploadButton';

function CardBlogs({ data, isHistoryBlogs = false, setFlagFetch }) {
    const navigate = useNavigate();
    const formattedDatePublished = format(new Date(data.createdAt), 'dd MMM yyyy');
    const formattedDateRemoved = format(new Date(data.deletedAt), 'dd MMM yyyy');
    const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
    const API_URL = import.meta.env.VITE_API_URL;
    const accessToken = useSelector((state) => state.user.accessToken);
    const { TextArea } = Input;
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [image, setImage] = useState(data.image);
    const [categoryList, setCategoryList] = useState([])
    const [loadingCategories, setLoadingCategories] = useState(false);
    const showEditModal = () => {
        form.setFieldsValue({
            title: data.title,
            title_ar: data.title_ar,
            description: data.description,
            description_ar: data.description_ar,
            Category: data?.categoryDetails?.id
        });
        setImage(data.image);
        setIsEditModalVisible(true);
    };
    const handleEditSubmit = async (values) => {
        console.log(values)
        if (image == "" || image == undefined || image == null) {
            message.error("Please add an image for the blog.")
            return;
        }
        const payload = {
            image: image,
            title: values.title,
            title_ar: values.title_ar,
            description: values.description,
            description_ar: values.description_ar,
            category: values.Category,
        }
        try {
            const response = await axios.post(`${API_URL}Blogs`, payload,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    }
                }
            )
            message.success("Blog Repost successfully.");
            setFlagFetch(1)
            setIsEditModalVisible(false)
            form.resetFields();
        } catch (error) {
            console.error("Error Repost blog:", error);
        }

    };
    useEffect(() => {
        fetchCategories()
    }, [])
    const fetchCategories = async () => {
        try {
            setLoadingCategories(true);
            const response = await axios.get(`${API_URL}Diseases/get-diseases`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            setCategoryList(response.data.Diseases.map(d => ({
                id: d.id,
                name: d.name,
            })));
        } catch (error) {
            console.error("Error fetching categories:", error);
        } finally {
            setLoadingCategories(false);
        }
    };
    const handleEditDetails = () => {
        navigate(`EditBlog/${data.id}`, { state: { data: data } });
    };
    const handleViewDetails = () => {
        navigate(`ViewBlog/${data.id}`, { state: { data: data } });
    };

    const handleDelete = async () => {
        try {
            const response = await axios.delete(`${API_URL}Blogs?id=${data.id}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
            if (response.status === 200) {
                message.success("Blog deleted successfully");
                setFlagFetch(1)
            }

        } catch (error) {
            console.error("Error deleting Blog:", error);
            message.destroy();
            message.error("Failed to delete Blog");
        }
    };
    // console.log(data)
    return (
        <>
            <Modal
                title="Repost Blog"
                visible={isEditModalVisible}
                onCancel={() => setIsEditModalVisible(false)}
                footer={null}
                width={800}
            >
                <Form form={form} onFinish={handleEditSubmit} layout="vertical">
                    <Form.Item
                        label="Blog Image"
                        name="image"
                        valuePropName="image"
                    >
                        <div className={`flex justify-center items-center min-h-96 bg-cover bg-center bg-no-repeat rounded-sm relative`}
                            style={{
                                backgroundImage: image ? `url(${image})` : "none",
                                backgroundColor: !image ? "#F7F8FF" : "transparent",
                            }}
                        >
                            <div className="absolute inset-0 bg-[#3371EB] opacity-50 pointer-events-none rounded-sm"></div>
                            <UploadButton
                                onChange={(url) => setImage(url)}
                                disabled={false}
                            />
                        </div>
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ color: "#232323", fontWeight: 500, fontSize: "16px" }}>Title Blog (EN)</span>}
                        name="title"
                        rules={[{ required: true, message: "Please Enter a Title Blog" }, { whitespace: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ color: "#232323", fontWeight: 500, fontSize: "16px" }}>Title Blog (AR)</span>}
                        name="title_ar"
                        rules={[{ required: true, message: "Please Enter a Title Blog" }, { whitespace: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ color: "#232323", fontWeight: 500, fontSize: "16px" }}>Category</span>}
                        name="Category"
                        rules={[{ required: true, message: "Please select a category" }]}
                    >

                        <Select
                            placeholder="Select a category"
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {categoryList.map(category => (
                                <Select.Option key={category.id} value={category.id}>
                                    {category.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ color: "#232323", fontWeight: 500, fontSize: "16px" }}>Paragraph (EN)</span>}
                        name="description"
                        rules={[{ required: true, message: "Please enter content" }, { whitespace: true }]}
                    >
                        <TextArea rows={4} />
                    </Form.Item>

                    <Form.Item
                        label={<span style={{ color: "#232323", fontWeight: 500, fontSize: "16px" }}>Paragraph (AR)</span>}
                        name="description_ar"
                        rules={[{ required: true, message: "Please enter content" }, { whitespace: true }]}
                    >
                        <TextArea rows={4} />
                    </Form.Item>

                    <div className="flex flex-row justify-between items-center">
                        <Button
                            className="px-9 py-6 text-[#3371EB] border-[#E0EAFC]"
                            onClick={() => setIsEditModalVisible(false)}
                        >
                            Discard
                        </Button>
                        <Button type="primary" className="px-7 py-6" htmlType="submit">
                            Repost
                        </Button>
                    </div>
                </Form>
            </Modal>
            <div className='bg-white p-5 rounded flex flex-col space-y-5 justify-between'>
                <div className='flex flex-col space-y-5'>
                    <div>
                        <ImageWithSkeleton
                            
                            src={data.image}
                            alt={data.title}
                            className="rounded"
                            style={{ width: "100%", height: "300px", objectFit: "cover" }}
                        />


                    </div>
                    <h2 className='text-lg font-semibold h-[55px] line-clamp-2'>{data.title}</h2>
                    <div className='bg-[#F7F8FF] py-1 rounded-xl w-fit px-4'>
                        <p className='text-[#3371EB] text-sm font-normal'>{data.categoryDetails.name}</p>
                    </div>
                    <p className='text-sm font-normal line-clamp-3'>{data.description}</p>
                </div>
                <div className='flex flex-col space-y-5'>
                    <div className='flex justify-between'>
                        <div>
                            <p className='text-xs font-normal'>Published Date:</p>
                            <p className='text-xs font-normal'>{formattedDatePublished == "01 Jan 1970" ? "null" : formattedDatePublished || 'No date provided'}</p>
                        </div>
                        {isHistoryBlogs && (<div>
                            <p className='text-xs font-normal'>Removed Date:</p>
                            <p className='text-xs font-normal'>{formattedDateRemoved == "01 Jan 1970" ? "No removal date" : formattedDateRemoved || 'No removal date'}</p>
                        </div>)}
                    </div>
                    <div className='flex flex-col-reverse justify-between gap-2'>
                        {userType == 4 ? null :
                            isHistoryBlogs ? null :
                                <>
                                    <Button
                                        className='flex-1 py-2'
                                        onClick={handleDelete}
                                        style={{
                                            borderColor: "#FF4D4F",
                                            color: "#FFFFFF",
                                            // padding: "25px 30px",
                                            // fontSize: "16px",
                                            backgroundColor: "#FF4D4F",
                                            fontWeight: "400"
                                        }}
                                    >
                                        Delete
                                    </Button>
                                    <Button onClick={handleEditDetails} className='text-[#295ABC] border-[#C0D3F9] flex-1 py-2'>Edit</Button>
                                </>
                        }
                        <Button onClick={handleViewDetails} type="primary" className='flex-1 py-2'>View</Button>
                        {
                            userType !== 4 && isHistoryBlogs && (
                                <span onClick={showEditModal} className='bg-[#E8FAE9] px-5 rounded-sm flex cursor-pointer hover:bg-[#D7E9D8] justify-center items-center p-2'>
                                    <AntIcon iconPath={'/assets/images/blog-card-restore-icon.svg'} />
                                </span>
                            )
                        }

                    </div>
                </div>
            </div>
        </>
    );
}

export default CardBlogs
